const vehicleTypes = { 
    'car': 'Car', 
    'boat': 'Boat',
    'jet_ski': 'Jet Ski',
    'bimin': 'Bimini',
    'pontoon': 'Pontoon',
    'motorcycle': 'Motorcycle',
    'scooter': 'Scooter',
    'atv': 'ATV',
    'utv': 'UTV',
    'snowmobile': 'Snowmobile',
    'suv': 'SUV',
    'truck': 'Truck',
    'van': 'Van'
}
const formatVehicleType = (vehicleType) => {
    return vehicleTypes[vehicleType] || vehicleType;
}

export default formatVehicleType;